import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'

import styles from 'src/styles/common.module.scss'

export const TextContentDe = () => {
    return (
        <HighlightedText
            text="SIE HABEN 400 FREISPIELE GEWONNEN FORTFAHREN"
            highlights={[{ word: '400' }, { word: 'FREISPIELE' }]}
            breakAfterWords={['HABEN', 'FREISPIELE', 'GEWONNEN']}
            className={styles.text_content}
        />
    )
}
